import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../../../components/PageTemplate/PageTemplate';
import JobAdCanidates from '../../../modals/components/layouts/business-dashboard/JobAdCanidates/JobAdCanidates';

export default function JobAdCanidatesPage() {
  const { t } = useTranslation();
  return (
    <Grid item lg={6} md={9} xs={12} sx={{ display: { xs: 'block' } }}>
      <PageTemplate title={t('candidates')} content={<JobAdCanidates />} />
    </Grid>
  );
}
